/** @jsxImportSource @emotion/react */
import { Color } from "react-color";
import { useForm, SubmitHandler, useFieldArray, Controller, UseFormWatch } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from "yup";
import { RequireValidateion } from "../../common/Validation";
import { css } from "@emotion/react";
import { cht_agent_bubble_cont, cht_agent_container, cht_agent_icon, cht_container, cht_content, cht_customer_bubble_cont, cht_footer, cht_footer_left, cht_customer_container, cht_headber, cht_headber_title, cht_wrapper, config_wrap, bubble, sendButton, cht_customer_icon } from "../../css/BaseCss";
import { IFormInputs } from "../Config";
import { BaseSyntheticEvent, RefObject, useRef } from "react";
import { InitMessages } from "./InitMessages";
import { WindowResize } from "../hooks/WindowResize";
import { InputBase } from "@mui/material";
import { watch } from "fs";

export const ChatMessageType = {
    system: 1,
    userdata: 2,
} as const
export type ChatMessageType = typeof ChatMessageType[keyof typeof ChatMessageType]

export type ChatData = {
    //message: string,
    //updateTime: Date,
    guestMessage: string,
    guestMessageTime: Date,
    adminMessage: string,
    adminMessageTime: Date,
    messageType: ChatMessageType,
}

/*export interface IFormInputs {
    question: string,
    chatMessageList: ChatData[],
    siteId: string,
}*/

export type ChatPreviewProp = {
    backgroundColor: Color,
    headerTitle: string,
    headercolor: Color,    
    adminbubblebackgroundcolor: Color,
    adminbubbletextcolor: Color,
    guestbubblebackgroundcolor: Color,
    guestbubbletextcolor: Color,
    footerText: string,
    footerbackgroundcolor: Color,
    footertextcolor: Color,
    footerButtonIcon: Blob,
    sendbuttoncolor: Color,
    headerImage: Blob,
    chatAdminIcon: Blob,
    chatGuestIcon: Blob,
    inittextlist: ChatData[],
    watch: UseFormWatch<IFormInputs>
}

const schema = Yup.object().shape({
    messages: Yup.array(
        Yup.object().shape({
            msgtext: RequireValidateion,
        })
    )
})

export const ChatPreview = (prop: ChatPreviewProp) => {

    const [windowWidth, windowHeight] = WindowResize();

    const cht_header_iconfile = css`
        background-image: url(${URL.createObjectURL(prop.watch("headerIcon")?.[0] ?? new Blob)});
    `

    const cht_agent_iconfile = css`
        background-image: url(${URL.createObjectURL(prop.watch("chatAdminIcon")?.[0] ?? new Blob)});
    `

    const cht_headber_color = css`
        background: ${prop.watch("headerColor")};
    `

    const cht_headertextarea_color = css`
        color: ${prop.watch("headerTextColor")};
    `

    const cht_content_color = css`
        background-color: ${prop.watch("backgroundColor")};
    `

    const cht_agent_textcolor = css`
        color: ${prop.watch("adminBubbleTextColor")};
    `

    const cht_agent_bubble_after = css`
        background: ${prop.watch("adminBubbleBackgroundColor")};
        ::after {
            border-color: transparent ${prop.watch("adminBubbleBackgroundColor")};
        }
    `

    const cht_customer_bubbleafter = css`
        background: ${prop.watch("guestBubbleBackgroundColor")};
        ::after {
            border-color: transparent ${prop.watch("guestBubbleBackgroundColor")};
        }
    `

    const cht_customer_textcolor = css`
        color: ${prop.watch("guestBubbleTextColor")};
    `

    const cht_footer_background = css`
        background-color: ${prop.watch("footerBackgroundColor")};        
    `

    const cht_footer_textarea = css`
        color: ${prop.watch("footerTextColor")};
        background-color: ${prop.watch("footerTextareaColor")};
        ::placeholder {
            color: ${prop.watch("footerTextareaPlaceholderColor")};
        }
    `
    /*const cht_footer_textarea = css`
        color: red;
        background-color: yellow;
    `*/

    const sendButtonImage = css`
        background-image: url(${URL.createObjectURL(prop.watch("sendButtonIcon")?.[0] ?? new Blob)});
    `
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const configDivRef = useRef<HTMLDivElement>(null);

    const chatBox = css`
        position: fixed;
        top: ${windowHeight * 0.1}px;
        left: ${((configDivRef.current?.clientWidth ?? 50) * 0.1)}px;
        width: ${((configDivRef.current?.clientWidth ?? 50) * 0.8)}px;
        height: ${windowHeight * 0.8}px;
    `

    const resizeTextHeight = (textarea: RefObject<HTMLTextAreaElement>) => {
        if(textarea.current != null){
            textarea.current.style.height = '40px';
            const scrollHeight = textarea.current.scrollHeight;
            textarea.current.style.height = `${scrollHeight}px`;
        }
    }

    return(
        <>
        <div css={ config_wrap } ref={configDivRef}>
            <div css={chatBox}>
                <div css={[cht_headber, cht_headber_color]}>
                    <div css={[cht_agent_icon, cht_header_iconfile]}></div>
                    <div css={[cht_headber_title, cht_headertextarea_color]}>{prop.watch("chatTitle")}</div>
                </div>
                <div css={[cht_container, cht_content_color]}>
                    <div css={cht_wrapper}>
                        <div css={cht_content}>
                            {
                                prop.watch("initMessageList").map((value, index, array) => {
                                    return (
                                        <div key={index} css={cht_agent_container}>
                                            <div css={[cht_agent_icon, cht_agent_iconfile]}></div>
                                            <div css={[cht_agent_bubble_cont, bubble, cht_agent_bubble_after]}>
                                                <div css={cht_agent_textcolor}>{value.msgtext}</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            <div css={cht_customer_container}>
                                <div css={[cht_customer_bubble_cont, bubble, cht_customer_bubbleafter]}>                                
                                <div css={cht_customer_textcolor}>利用者の吹き出しサンプルです。</div>                                
                                </div>
                            </div>
                            <div css={cht_agent_container}>
                                <div css={[cht_agent_icon, cht_agent_iconfile]}></div>
                                <div css={[cht_agent_bubble_cont, bubble, cht_agent_bubble_after]}>
                                <div css={cht_agent_textcolor}>ボットの吹き出しサンプルです。</div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>

                <div id="footer" css={ [cht_footer, cht_footer_background] }>
                    <div style={{width: "100%"}}>
                        <InputBase inputProps={
                            {
                                style:{
                                    color: prop.watch("footerTextColor"),
                                    backgroundColor: prop.watch("footerTextareaColor"),
                                    borderRadius: "5px 5px 5px 5px",
                                    paddingLeft: "5px",
                                    paddingRight: "5px",
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    marginRight: "10px",
                                },
                                sx:{
                                    '::placeholder' : {color: prop.watch("footerTextareaPlaceholderColor")}
                                }
                            }
                        } fullWidth multiline placeholder={prop.watch("footerText")}></InputBase>
                    </div>
                    <div>
                        <input type="submit" value="" css={[sendButton, sendButtonImage]} />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}